<template>
	<!-- 未使用 -->
	<div class="page">
		<div class="columnTitle">
			<div class="columnTitleL">门店信息</div>
			<div class="columnTitleR">
				<el-button type="primary" @click="$router.back()">查看更多信息</el-button>
				<el-button type="success" @click="$router.back()">编辑门店</el-button>
				<el-button type="warning" @click="$router.back()">返回</el-button>
			</div>
		</div>
		<div class="baseMsgLine">
			<div class="cover">
				<img class="img" :src="shopInfo.cover"/>
			</div>
			<div class="coverR">
				<div class="storeName">
					{{shopInfo.shopName}}
				</div>
				<div class="storeMsg">
					<div class="storeMsgItem">
						<div class="l">门店地址:</div>
						<div class="v">{{shopInfo.address}}</div>
					</div>
					<div class="storeMsgItem">
						<div class="l">门店电话:</div>
						<div class="v">{{shopInfo.tel}}</div>
					</div>
					<div class="storeMsgItem">
						<div class="l">营业时间:</div>
						<div class="v">{{shopInfo.workTime}}</div>
					</div>
					<div class="storeMsgItem">
						<div class="l">建筑面积:</div>
						<div class="v">{{shopInfo.builtUpArea}}</div>
					</div>
					<div class="storeMsgItem">
						<div class="l">门店状态:</div>
						<div class="v">
							{{shopInfo.status===0?'禁用':''}}
							{{shopInfo.status===1?'启用':''}}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="columnTitle" style="margin-top:16px;">
			<div class="columnTitleL">门店员工</div>
			<div class="columnTitleR">
			</div>
		</div>
		<div class="navBox">
			<div style="display: flex;">
				<div class="navItem" :class="curNavIndex===0?'active':''" @click="changeCurNavIndex(0)">员工</div>
			</div>
			<div style="display: flex;justify-content: flex-end;">
			</div>
		</div>
		<div class="contentBox">
			
		</div>
		
	</div>
</template>

<script>
	export default {
		components:{},
		data() {
			return {
				
				curNavIndex:0,
				
				shopInfo:{},
				
			}
		},
		computed:{
			
		},
		created(){
			
		},
		mounted(){
			this.getShopInfo()
		},
		methods:{
			changeCurNavIndex(i){
				this.curNavIndex=i;
			},
			getShopInfo() {
				let params = {
					"id": this.$route.query.id,
					companyId:'5e9412e0b2bfbc030160bdd5',
				}
				this.$http.get(process.env.VUE_APP_baseData+'/api/CompanyInfo/shop/info', params).then(res => {
					if (res.code == 0) {
						this.shopInfo = res.data;
					}
				})
			},
			
			
		},
	}
</script>

<style lang="scss" scoped>
	.page{
		padding:16px 16px;height: 100%;box-sizing: border-box;position: relative;overflow: auto;
		.columnTitle{
			display: flex;justify-content: space-between;
			.columnTitleL{
				font-size: 18px;color:$color333;line-height: 40px;font-weight: bold;
				&::before{
					display: inline-block;content:'';width:4px;height: 20px;background: linear-gradient(315deg, #338AFF 0%, #3F69FF 100%);border-radius: 4px;margin-right: 12px;vertical-align: sub;
				}
			}
			.columnTitleR{
				
			}
		}
		.baseMsgLine{
			margin-top:16px;display: flex;background-color: #fff;height: 200px;border-radius: 8px;
			.cover{
				width:300px;flex-shrink: 0;padding:10px;
				.img{
					height:100%;
				}
			}
			.coverR{
				width:100%;
				.storeName{
					font-size: 20px;font-weight: bold;padding:25px 20px 10px 20px;
				}
				.storeMsg{
					display: flex;flex-wrap: wrap;
					.storeMsgItem{
						width:50%;display: flex;line-height: 45px;font-size: 14px;color:$color333;
						.l{
							width:80px;text-align: right;margin-right: 10px;flex-wrap: wrap;flex-shrink: 0;
						}
						.v{
							width:100%;
						}
					}
				}
			}
		}
		.navBox{
			width:100%;height: 68px;border-radius: 12px;background-color: #F0EDF7;margin-top:6px;display: flex;justify-content: space-between;padding:8px;box-sizing: border-box;
			.navItem{
				height: 52px;border-radius: 8px;padding:0 22px;font-size: 14px;color:$color333;line-height: 52px;cursor: pointer;
				&.active{
					background: linear-gradient(135deg, #5685FF 0%, #3569FF 100%);color:#fff;
				}
			}
			.navItem1{
				height: 52px;border-radius: 8px;padding:0 22px;font-size: 14px;color:$color333;cursor: pointer;text-align: center;
				&.active{
					background: linear-gradient(135deg, #5685FF 0%, #3569FF 100%);color:#fff;
					.la{
						color:#fff;
					}
					.va{
						color:#fff;
					}
				}
				.la{
					font-size: 14px;color:$color666;padding-top:10px;
				}
				.va{
					font-size: 16px;color:$color333;padding-top:6px;
				}
			}
		}
		.contentBox{
			height: calc(100% - 84px);
		}
	}
</style>
